<template>
    <b-list-group-item :href="href" class="country-item">
        <img :src="flagSvg" width="32px" height="32px" class="flag">
        <span class="country-title">{{ title }}</span>
        <img :src="logo" class="logo float-right" width="91px" height="24px">
    </b-list-group-item>
</template>

<script>
    export default {
        name: "countryItem",
        props: {
            href: {
                type: String,
                default: "#"
            },
            flagSvg: {
                type: String,
                default: "",
            },
            title: {
                type: String,
                default: "",
            },
            logo: {
                type: String,
                default: "",
            }
        }
    }
</script>
<style lang="scss">
    @import "./src/assets/scss/variables";
    @import "./node_modules/bootstrap/scss/functions";
    @import "./node_modules/bootstrap/scss/variables";
    @import "./node_modules/bootstrap/scss/mixins";

    @include media-breakpoint-only(xs) {
        .country-item {
            font-size: $font-size-base * 1.2;
            line-height: 32px;
            padding: $list-group-item-padding-y $list-group-item-padding-x / 2;

            .country-title {
                padding-left: $list-group-item-padding-x / 3;
            }
        }
    }

    .country-item {
        height: 57px;
        overflow: hidden;
    }

    .country-title {
        width: 50%;
        width: calc(100% - 123px);
        display: inline-block;
        height: 32px;
        line-height: 32px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: top;
    }
    img.flag {
        vertical-align: baseline;
    }
    img.logo {
        margin-top: 3px;
    }

</style>